import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-payment-error',
    templateUrl: './payment-error.component.html',
    styleUrls: ['./payment-error.component.scss'],
    standalone: false
})
export class PaymentErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
